import React from 'react'
import useScrollVisibility from 'hooks/useScrollVisibility'

// assets
import instagram from 'assets/icons/instagram.svg'
import facebook from 'assets/icons/facebook.svg'
import email from 'assets/icons/email.svg'

function ContactsSection() {
  return (
    <div className='flex flex-1 flex-col gap-2'>
      <header className='text-2xl font-semibold uppercase md:text-4xl'>Contatos</header>
      <ul className='flex flex-col gap-2'>
        <li>
          <a
            href='tel:554334727949'
            target='_blank'
            rel='noopener noreferrer'
            className='transition-all duration-500 hover:text-golden'
          >
            (43) 3472-7949
          </a>
        </li>
        <li>
          <a
            href='https://api.whatsapp.com/send?phone=5543998255439&text=Ol%C3%A1%2C%20gostaria%20de%20agendar%20uma%20consultoria'
            target='_blank'
            rel='noopener noreferrer'
            className='transition-all duration-500 hover:text-golden'
          >
            (43) 99825-5439
          </a>
        </li>
        <li>
          <a
            href='mailto:maciasecruz@hotmail.com'
            target='_blank'
            className='transition-all duration-500 hover:text-golden'
          >
            maciasecruz@hotmail.com
          </a>
        </li>
        <li>
          <a
            href='https://maps.app.goo.gl/c47WTa31QqrhpsZbA'
            target='_blank'
            className='transition-all duration-500 hover:text-golden'
          >
            Praça Yvens Gueguem, 455 - <br /> Ivaiporã, PR, 86870-000
          </a>
        </li>
      </ul>
    </div>
  )
}

function OfficeSection() {
  return (
    <div className='flex flex-1 flex-col gap-2'>
      <header className='text-2xl font-semibold uppercase md:text-4xl'>O Escritório</header>
      <p className='text-justify'>
        Entre em contato conosco e descubra como podemos ajudar você, a proteger seus interesses e garantir seu sucesso.
      </p>
    </div>
  )
}

function SocialMediaSection() {
  return (
    <div className='flex flex-1 flex-col items-start gap-2 md:items-center'>
      <ul className='flex items-center gap-2'>
        <li>
          <a href='https://www.instagram.com/maciasecruz.advocacia/' target='_blank'>
            <img
              src={instagram}
              alt='Instagram'
              loading='lazy'
              className='h-16 w-16 transition-all duration-500 hover:opacity-50'
            />
          </a>
        </li>
        <li>
          <a href='https://www.facebook.com/profile.php?id=61559411923577' target='_blank'>
            <img
              src={facebook}
              alt='Facebook'
              loading='lazy'
              className='h-16 w-16 transition-all duration-500 hover:opacity-50'
            />
          </a>
        </li>
        <li>
          <a href='mailto:maciasecruz@hotmail.com' target='_blank'>
            <img
              src={email}
              alt='Email'
              loading='lazy'
              className='h-16 w-16 transition-all duration-500 hover:opacity-50'
            />
          </a>
        </li>
      </ul>
    </div>
  )
}

function CopyrightSection({ getYear }) {
  return (
    <div className='flex w-full flex-col justify-center gap-1 bg-white p-2 text-dark md:flex-row'>
      <a href={`#${getYear()}`} target='_blank'>
        &copy;{getYear()} Macias & Cruz Advocacia.
      </a>
      <a href='https://dorac.com.br' target='_blank'>
        Desenvolvido por Agência Dorac
      </a>
    </div>
  )
}

function Footer() {
  const [isVisible, sectionRef] = useScrollVisibility('footer-section')

  const getYear = () => {
    return new Date().getFullYear()
  }

  return (
    <footer ref={sectionRef} className='flex w-full flex-col items-center justify-between bg-dark'>
      <div className='m-8 flex min-h-48 w-11/12 flex-col justify-between gap-8 text-xl text-white md:mt-8 md:w-10/12 md:flex-row'>
        <ContactsSection />
        <OfficeSection />
        <SocialMediaSection />
      </div>

      <CopyrightSection getYear={getYear} />
    </footer>
  )
}

export default Footer
